import React from 'react'
import {useSelector} from 'react-redux'
import {isEmpty, isUndefined} from 'lodash'
import {Close, FilterListOutlined} from '@material-ui/icons';
import {Tooltip, IconButton, Menu, makeStyles, Divider, Grid, TextField, Select, MenuItem, InputLabel,FormControl,Button, Chip, Badge} from '@material-ui/core'
import moment from 'moment-timezone'
import ArendeTypeCategory from './ArendeTypeCategory'
import DateRangeComponent from './DateRangeComponent'
import Fab from '@material-ui/core/Fab';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const useStyles = makeStyles({
  menu: {
    '& .MuiMenu-paper': {
      width: '375px',
      paddingLeft: '10px',
      paddingRight: '10px',
    }
  },
  w30px: {
    width: 30
  },
  cardSideOptionsButton: {
    textTransform: 'none'
  },
  badge: {
    top: 4,
    right: 3,
    transform: 'scale(0.75) translate(50%, -50%)'
  },
});

function WidgetFilter(props) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterArr, setFilterArr] = React.useState([])
  let DateCreated = props.intl.formatMessage({ id: 'Created' });
  const handleClick = (event) => {
    setFilterArr(props.filterArr)
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSetFilter = () => {
    setAnchorEl(null)
    props.setFilterArr(filterArr)
  }

  const handlePushFilter = (filter) => {
    setFilterArr(s => [...s, filter])
  }
  const handlePushFilterArr = (filter) => {
    setFilterArr(s => [...s, ...filter])
  }

  const handleDeleteFilter = (index) => {
    setFilterArr(s => { 
      let arr = [...s]
      arr.splice(index, 1)
      return arr
    })
  }

  const parseFilter = (filter) => {
    
  // '{"Meta":"Typ","Value":"Fråga"}',
  // '{"Meta":"Typ","Value":"test1"}',
  // '{"Meta":"Category","Value":"333"}'
    try {
      let filterObj = JSON.parse(filter)
      switch(filterObj.Meta) {
        case 'Typ': return `${props.intl.formatMessage({ id: 'appKontoModule.Type' })}: ${filterObj.Value}`
        case 'Category': return `${props.intl.formatMessage({ id: 'Category.label' })}: ${filterObj.Value}`
        case 'DatumFrom': return `${props.intl.formatMessage({ id: 'From' })}:  ${moment(filterObj.Value).format('YYYY-MM-DD')}`
        case 'DatumTo': return `${props.intl.formatMessage({ id: 'To' })}: ${moment(filterObj.Value).format('YYYY-MM-DD')}`
        default: return ''
      }
    } catch (err){
      console.log(err)
      return ''
    }
  }

  return (
    <>
      <Tooltip title={<IntlMessages id="Filter"/>}>
        <IconButton onClick={handleClick} size="small" color="primary">
          <Badge badgeContent={props.filterArr.length} color="secondary" invisible={props.filterArr.length === 0} classes={{anchorOriginTopRightRectangle: classes.badge}}>
            <FilterListOutlined/>
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.menu}
        variant={'menu'}
      >
        <div className="d-flex align-items-center justify-content-between w-100">
          <span className={classes.w30px}>
            
          </span>
          <span>
          <IntlMessages id="Filter"/>
          </span>
          <span><IconButton size="small" onClick={handleClose}><Close style={{fontSize: 18}}/></IconButton></span>
        </div>
        <Divider className={'mt-2 mb-3'}/> 
        <Grid container spacing={1}>
          { !isEmpty(props.filterOptions.filter(s => s === 'case-type-category')) &&
            <ArendeTypeCategory
              handlePushFilter={handlePushFilter}
            />}
          { !isEmpty(props.filterOptions.filter(s => s === 'date-range')) &&
            <DateRangeComponent
              handlePushFilter={handlePushFilterArr}
              Meta={'Datum'}
              Label={DateCreated}
            />}
          <Grid item xs="12" className='mb-1'>
            {filterArr.map((f, index) => {
              return <Chip size='small' color="primary" className='mr-1 mt-1' onDelete={() => handleDeleteFilter(index)} label={parseFilter(f)}/>
            })}
          </Grid>
          <Grid item xs="12">  
            <Button
              fullWidth
              onClick={handleSetFilter}
              color="primary"
              variant="outlined"
              size="small"
            >
              <IntlMessages id="Filter.Button"/>
            </Button>
          </Grid>
        </Grid>
      </Menu>
    </>
  )
}

export default injectIntl(WidgetFilter);